import { configureStore } from '@reduxjs/toolkit';
import defaultValueReducer from '../slices/defaultValueSlice';
import { authReducer } from '../slices/auth.slice';
import { usersReducer } from '../slices/users.slice';
import  pageReducer  from '../slices/page.slice';
import invoicesReducer from '../slices/invoices.slice';
import returnedInvoicesReducer from '../slices/returnedInvoices.slice';
import accountReviewReducer from '../slices/accountReview.slice';
import receiptsReducer from '../slices/receipts.slice';
import paymentReducer from '../slices/payment.slice';
import stOrderReducer from '../slices/storder.slice';
import rxOrderReducer from '../slices/rxorder.slice';
import matrixReducer from '../slices/matrix.slice';
import ordersReducer from '../slices/orders.slice';
import saleDepartmentReducer from '../slices/saleDepartment.Slice';
import changePassReducer from '../slices/changePass.Slice';

import statisticsReducer from '../slices/statistics.slice';

export * from '../slices/auth.slice';
export * from '../slices/users.slice';
//export * from '../slices/invoices.slice';
//export * from '../slices/statistics.slice';

export const store = configureStore({
  reducer: {
    defaultValue: defaultValueReducer,
    auth: authReducer,
    users: usersReducer,
    page : pageReducer,
    invoices : invoicesReducer,
    returnedInvoices : returnedInvoicesReducer,
    statistics : statisticsReducer,
    accountReview : accountReviewReducer,
    receipts : receiptsReducer,
    payment : paymentReducer,
    stOrder : stOrderReducer,
    rxOrder : rxOrderReducer,
    matrix : matrixReducer,
    orders : ordersReducer,
    saleDepartment : saleDepartmentReducer,
    changePass : changePassReducer
  },
});